// Lista dei country disponibili forniti da Shopify (Liquid)
window.shopifyMarketsCountries = [];

// Se l'utente cambia manualmente country dal selettore, non riproporre la popup
document.addEventListener("click", function (e) {
  var countrySelectorLink = e.target.closest("country-selector a");
  if (countrySelectorLink) {
    document.cookie = "lang_popup_shown=true; path=/; max-age=86400";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Skip totale per bot / crawler
  if (window.isCrawlerUserAgent && window.isCrawlerUserAgent()) {
    return;
  }

  // ---------------------------------------------------
  // Utility indipendenti da CF
  // ---------------------------------------------------
  function getBrowserLang() {
    var lang = (navigator.language || "").toLowerCase();
    return lang.startsWith("it") ? "it" : "en";
  }

  function getSiteLang() {
    return (document.documentElement.getAttribute("lang") || "en").toLowerCase();
  }

  function getTargetCountry(cfInfo) {
    var browserLang = getBrowserLang();
    var siteLang = getSiteLang();
    var validCountries = window.shopifyMarketsCountries || [];

    // Country corrente da CF: preferisco cfInfo.country, poi eventuale window.cloudflareCountry
    var currentCountry =
      (cfInfo && cfInfo.country) ||
      window.cloudflareCountry ||
      "";

    // Sito in EN, browser in IT → proponi IT
    if (siteLang === "en" && browserLang === "it") {
      return "IT";
    }

    // Sito in IT, browser non IT → proponi la country CF se è un market valido, altrimenti IE
    if (siteLang === "it" && browserLang !== "it") {
      return validCountries.includes(currentCountry) ? currentCountry : "IE";
    }

    return null;
  }

  // ---------------------------------------------------
  // Core del popup
  // ---------------------------------------------------
  function runLangPopup(cfInfo) {
    // Già mostrata nelle ultime 24h?
    if (document.cookie.includes("lang_popup_shown=true")) return;

    // Se lingua browser = lingua sito, non ha senso mostrare nulla
    var browserLang = getBrowserLang();
    var siteLang = getSiteLang();
    if (browserLang === siteLang) return;

    var texts = {     
      question: "Parli Italiano?",
      yes: "Sì, cambia lingua",
      no: "No, english is ok"      
    };

    var popupLang = browserLang === "it" ? "it" : "en";

    var overlay = document.createElement("div");
    overlay.style.cssText = [
      "position: fixed",
      "top: 0",
      "left: 0",
      "width: 100%",
      "height: 100%",
      "background: rgba(0,0,0,0.6)",
      "z-index: 9998"
    ].join(";");

    var wrapper = document.createElement("div");
    wrapper.innerHTML = `
      <div 
        style="
          position:fixed;
          top:50%;
          left:50%;
          transform:translate(-50%, -50%);
          background:#fff;
          padding:24px;
          z-index:9999;
          box-shadow:0 0 15px rgba(0,0,0,0.3);
          width:500px;
          max-width:90vw;
          text-align: center;
        ">
        <button id="langPopupClose" style="
          position: absolute;
          top: 5px;
          right: 8px;
          background: transparent;
          border: none;
          font-size: 20px;
          cursor: pointer;
        ">&times;</button>
        <h4>${texts.question}</h4>
        <button class="btn btn--primary w-full" id="langSwitchBtn" style="margin: 24px 0 0;">
          ${texts.yes}
        </button>
        <br>
        <button class="btn btn--secondary w-full" id="langDismissBtn" style="margin: 24px 0 0;">
          ${texts.no}
        </button>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(wrapper);

    function dismissPopup() {
      document.cookie = "lang_popup_shown=true; path=/; max-age=86400";
      overlay.remove();
      wrapper.remove();
    }

    document.getElementById("langSwitchBtn").addEventListener("click", function () {
      document.cookie = "lang_popup_shown=true; path=/; max-age=86400";

      var targetCountry = getTargetCountry(cfInfo);
      if (targetCountry) {
        var form = document.createElement("form");
        form.method = "POST";
        form.action = "/localization";
        form.innerHTML = `
          <input type="hidden" name="form_type" value="localization">
          <input type="hidden" name="utf8" value="✓">
          <input type="hidden" name="_method" value="put">
          <input type="hidden" name="return_to" value="${window.location.pathname}${window.location.search}${window.location.hash}">
          <input type="hidden" name="country_code" value="${targetCountry}">
        `;
        document.body.appendChild(form);
        form.submit();
      } else {
        dismissPopup();
      }
    });

    document.getElementById("langDismissBtn").addEventListener("click", dismissPopup);
    document.getElementById("langPopupClose").addEventListener("click", dismissPopup);
  }

  // ---------------------------------------------------
  // Scheduling: 2s + prima interazione
  // ---------------------------------------------------
  function schedulePopup(cfInfo) {
    setTimeout(function () {
      var interacted = false;

      function removeListeners() {
        window.removeEventListener("mousemove", onInteract);
        window.removeEventListener("scroll", onInteract);
        window.removeEventListener("touchstart", onInteract);
      }

      function onInteract() {
        if (interacted) return;
        interacted = true;
        removeListeners();
        runLangPopup(cfInfo);
      }

      window.addEventListener("mousemove", onInteract);
      window.addEventListener("scroll", onInteract);
      window.addEventListener("touchstart", onInteract);

      // Dopo 10s se non ha mai interagito, smetti di ascoltare
      setTimeout(removeListeners, 10000);
    }, 2000);
  }

  // ---------------------------------------------------
  // Start: usa runWithCfInfo se disponibile, altrimenti fallback
  // ---------------------------------------------------
  function startLangPopup() {
    if (typeof window.runWithCfInfo === "function") {
      window.runWithCfInfo(function (cfInfo) {
        schedulePopup(cfInfo || null);
      });
    } else {
      // Nessun CF info disponibile → fallback (popup funziona lo stesso, meno preciso sul country)
      schedulePopup(null);
    }
  }

  startLangPopup();
});
